/* eslint-disable max-len */
// Single dictionary for FR (source), EN, ES, IT.
// All site content goes through useT(path).
import { servicesContent } from "./servicesContent";

export const dictionaries = {
  fr: {
    nav: { accueil: "Accueil", apropos: "À propos", vision: "Vision", offres: "Services", contact: "Contact" },
    common: {
      devis: "Prendre rendez-vous",
      decouvrirOffres: "Découvrir les offres",
      retourAccueil: "Retour à l'accueil",
      enSavoirPlus: "En savoir plus",
      envoyer: "Envoyer",
      sending: "Envoi...",
      decouvrir: "Découvrir nos offres",
      successDevis: "Merci ! Nous vous répondons sous 24 h.",
      successContact: "Demande envoyée ! Nous vous recontactons rapidement.",
      successNewsletter: "Merci ! Vous êtes inscrit·e à nos actualités.",
      errorGeneric: "Une erreur est survenue. Réessayez.",
    },
    popup: {
      title: "Bienvenue",
      subtitle: "Je veux m'inscrire et recevoir vos actualités.",
      placeholder: "Votre adresse e-mail",
      close: "Fermer",
    },
    home: {
      heroTitle1: "Agence de Création",
      heroTitleItalic: "Visuelle &",
      heroTitle2: "Marketing Digital",
      heroTagline: "Imposez votre signature visuelle.",
      heroCta: "Découvrir nos services",
      heroCta2: "Réserver un appel découverte",
      floatingCta: "Réserver un appel",
      floatingClose: "Fermer",
      heroLabel: "Monaco",
      intro1: "Chez EVARA, nous pensons qu'une marque doit se ressentir avant même d'être comprise.",
      intro2: "Nous accompagnons entrepreneurs, commerces, restaurants et marques dans leur développement digital avec une approche claire : **un contenu de qualité**, **une identité cohérente** et un message capable d'attirer naturellement.",
      intro3: "Notre mission est de créer un **univers visuel unique** pour chaque client, en alliant **créativité, stratégie** et une esthétique inspirée de l'**élégance monégasque**.",
      signaturePhrase: "Votre image. Votre signature.",
      approcheTitle: "Notre approche",
      approcheSub: "Comment fonctionne EVARA ?",
      steps: [
        { t: "Analyse", d: "Nous commençons par analyser **votre marque, votre marché et votre audience** afin de comprendre vos objectifs et identifier les opportunités de développement." },
        { t: "Prise de rendez-vous", d: "Nous organisons ensuite un rendez-vous afin d'échanger sur votre projet, vos besoins et la **direction stratégique** la plus adaptée à votre marque." },
        { t: "Stratégie", d: "Nous élaborons une **stratégie sur mesure** alignée avec vos objectifs afin de positionner efficacement votre marque." },
        { t: "Création de contenu", d: "Nous concevons et produisons des contenus adaptés à votre image afin de renforcer votre **visibilité** et votre **impact**." },
        { t: "Optimisation et suivi", d: "Nous assurons un suivi régulier et optimisons les actions mises en place afin de garantir des **résultats durables**." },
      ],
      offresTitle: "Comment voulez-vous marquer les esprits sur les réseaux sociaux ?",
      offresSub: "Des solutions sur-mesure pour chacun de vos besoins.",
      trustTitle: "Ils nous ont fait confiance",
      tiers: [
        { title: "Démarrer sur les réseaux sociaux", desc: "Vous souhaitez créer ou tester votre présence en ligne et commencer à publier du contenu régulièrement.", note: "(1 plateforme)" },
        { title: "Maintenir une présence régulière", desc: "Vous voulez rester actif sur les réseaux avec du contenu cohérent et une image professionnelle.", note: "(2 plateformes)" },
        { title: "Développer votre visibilité et votre audience", desc: "Vous voulez attirer plus de clients et faire grandir votre audience grâce à une stratégie optimisée.", note: "(2 plateformes ou plus)" },
        { title: "Construire une véritable marque", desc: "Vous souhaitez déléguer la gestion de vos réseaux et développer une véritable identité.", note: "(2 plateformes ou plus)" },
      ],
      devisTitle: "Réserver un échange",
      devisSub: "Discutons ensemble de votre projet et de vos ambitions digitales.",
      devisPrenom: "Prénom *",
      devisNom: "Nom de famille *",
      devisEmail: "E-mail *",
    },
    apropos: {
      title: "À propos",
      s1: [
        "Fondée à Monaco, EVARA est avant tout le fruit d'une passion pour la **création visuelle** et le **marketing digital**.",
        "Nous accompagnons les marques et les entreprises dans le développement de leur présence en ligne en proposant une gamme complète de services : **stratégie digitale, gestion des réseaux sociaux, création de contenu, branding** et accompagnement marketing.",
        "Notre objectif est d'aider chaque marque à structurer son image et à construire une **présence digitale forte et cohérente**.",
      ],
      s2: [
        "Chaque projet est pensé sur mesure afin de refléter l'**identité unique** de nos clients et de capter l'attention sur Instagram, Facebook, TikTok, LinkedIn et bien au-delà.",
        "De la réflexion stratégique à la production de contenu, nous combinons **créativité, stratégie et performance** pour transformer votre présence digitale en un véritable **levier de croissance**.",
      ],
      s3: [
        "Le nom EVARA, inspiré de « everyone » et « everlasting », symbolise la **confiance** et les **relations durables** que nous construisons avec nos clients.",
        "Il incarne une vision **moderne, élégante et tournée vers l'international**.",
      ],
      s3Quote: "EVARA, c'est plus qu'une agence : c'est une signature.",
      s4: [
        "À l'origine de cette agence se trouve avant tout une sensibilité pour **l'esthétique, le détail** et la manière dont une marque peut laisser une **empreinte durable**.",
        "« Au fil de mon parcours, j'ai développé une conviction forte : aujourd'hui, se démarquer ne repose plus uniquement sur ce que l'on propose, mais sur **la façon dont on le raconte** et dont on le fait vivre. »",
        "C'est cette vision qui guide chaque projet. Comprendre en profondeur l'univers, les ambitions et l'identité d'une marque est essentiel pour construire une présence à la fois **cohérente, impactante et durable**.",
        "EVARA est née de cette exigence : accompagner des marques ambitieuses avec **justesse, créativité** et une approche profondément **humaine**.",
      ],
      founderCaption: "Fondatrice d'EVARA",
      ctaBanner: "Et si on donnait une signature à votre marque ?",
    },
    vision: {
      title: "Chez EVARA,",
      p1: "Nous concevons des stratégies et des contenus qui permettent aux marques de **se démarquer** dans un univers digital en constante évolution.",
      p2: "Notre mission est d'allier **créativité, identité et performance** afin de construire des présences en ligne fortes, cohérentes et mémorables.",
      block1: "Notre expertise s'articule autour de **quatre piliers essentiels** : **la création de contenu, la gestion des réseaux sociaux, le branding et la conception de supports visuels**. Ces services ont été développés pour accompagner les marques à chaque étape de leur évolution, de la construction de leur identité à la croissance de leur visibilité.",
      block2: "Chaque collaboration est **entièrement sur mesure**. Les besoins d'une marque étant uniques, nos offres sont modulables et adaptées à vos objectifs, afin de proposer un accompagnement **flexible, stratégique et durable**.",
      piliersTitle: "Nos piliers",
      services: {
        "creation-de-contenu": "Création de contenu",
        "social-media-management": "Social Media Management",
        "branding-identite-visuelle": "Branding & identité visuelle",
        "creations-print": "Créations print et supports physiques",
      },
    },
    offres: {
      title: "Choisissez votre signature",
      subtitle: "Quatre services, chacun décliné en plusieurs niveaux d’accompagnement, pour répondre aux besoins de votre marque et soutenir son développement à chaque étape.",
      moreInfo: "Plus d'infos",
      offers: {
        FOCUS: "Idéal pour les entreprises souhaitant démarrer ou tester leur présence sur un seul réseau social.",
        START: "Idéal pour les micro-entreprises et PME, souhaitant développer leur présence sur les réseaux sociaux.",
        ESSENTIAL: "Idéal pour les PME et ETI, souhaitant accélérer leur visibilité et attirer davantage de clientèle.",
        PREMIUM: "Idéal pour les GE et marques établies souhaitant déléguer entièrement leur présence digitale et créer de l'impact.",
      },
      modulableIntro: "Encore des doutes ? On a pensé à vous.",
      modulableTitle: "Offre modulable",
      modulableDesc: "Idéal pour les entreprises souhaitant personnaliser leur développement digital.",
    },
    contact: {
      title: "Nous contacter",
      adresseLabel: "Adresse",
      adresseValue: "Monaco, 98 000",
      contactLabel: "Contact",
      horairesLabel: "Horaires d'ouverture",
      horaires: ["Lun–Ven · 10h – 14h", "Samedi · Fermé", "Dimanche · Fermé"],
      rdvTitle: "Prenons rendez-vous",
      rdvDesc: "Partagez-nous quelques informations sur votre entreprise et vos besoins. Cela nous permettra de mieux comprendre votre projet et de préparer notre premier échange.",
      formNom: "Nom *",
      formEmail: "E-mail *",
      formTel: "Numéro de téléphone",
      formType: "Êtes-vous un professionnel ou un particulier ?",
      typePro: "Professionnel",
      typePart: "Particulier",
      formSecteur: "Dans quel secteur êtes-vous ?",
      formSecteurPlaceholder: "Choisir un secteur…",
      formBudget: "Budget mensuel",
      formBudgetPlaceholder: "Choisir un budget…",
      formServices: "Quel(s) service(s) vous intéresse(nt) ?",
      formSource: "Comment avez-vous connu EVARA ?",
      formSourcePlaceholder: "Sélectionnez…",
      formMessage: "Des questions ou détails à partager ?",
      formSubmit: "Finaliser ma demande",
      formIntro: "Dites-nous en un peu plus sur vous…",
      secteurs: ["Restauration", "Hôtellerie", "Immobilier", "Luxe", "Mode & Beauté", "Santé & Bien-être", "Conseil & Services B2B", "Commerce de détail", "Sport & Fitness", "Événementiel", "Autre"],
      budgets: ["< 500 €", "500 € – 1 500 €", "1 500 € – 3 000 €", "3 000 € – 5 000 €", "5 000 € +", "À définir"],
      sources: ["Instagram", "LinkedIn", "TikTok", "Recommandation", "Google", "Autre"],
      services: ["Création de contenu", "Social media management", "Branding & identité visuelle", "Création de logo", "Créations print & supports physiques"],
    },
    serviceDetail: {
      back: "Retour",
      prestationsHidden: "Prestations",
      otherServicesHidden: "Nos autres piliers",
      data: {
        "creation-de-contenu": {
          label: "Création de contenu",
          title: "Production de contenu à forte valeur ajoutée",
          description: "Nous concevons et produisons des contenus visuels pensés pour **capter l'attention et valoriser votre marque** sur l'ensemble de vos canaux. Chaque projet s'inscrit dans une réflexion stratégique afin d'assurer **cohérence, qualité d'exécution et impact**.",
          prestations: ["Production photo & vidéo", "Formats courts (Reels, TikTok)", "Direction artistique", "Post-production & montage"],
        },
        "social-media-management": {
          label: "Social Media Management",
          title: "Gestion stratégique de vos réseaux sociaux",
          description: "Nous prenons en charge la **gestion complète** de votre présence sur les réseaux sociaux, en élaborant des stratégies sur mesure pour **développer votre audience, engager votre communauté** et renforcer l'identité de votre marque.",
          prestations: ["Stratégie éditoriale & calendrier", "Community management", "Publication et engagement", "Analyse des performances & reporting"],
        },
        "branding-identite-visuelle": {
          label: "Branding & identité visuelle",
          title: "Construction d'une identité visuelle forte",
          description: "Nous créons des **univers visuels uniques et cohérents** qui permettent à votre marque de se démarquer durablement. De la conception du logo à la définition complète de votre identité, nous construisons une **signature visuelle à votre image**.",
          prestations: ["Création de logo", "Charte graphique", "Direction artistique", "Univers visuel & moodboard"],
        },
        "creations-print": {
          label: "Créations print et supports physiques",
          title: "Supports physiques au service de votre marque",
          description: "Nous concevons des **supports imprimés haut de gamme** pour prolonger votre identité dans le monde physique. Cartes de visite, brochures, flyers, packaging : chaque création est pensée pour refléter **l'élégance et la qualité de votre marque**.",
          prestations: ["Cartes de visite & papeterie", "Brochures & catalogues", "Flyers & affiches", "Packaging & supports événementiels"],
        },
      },
    },
    footer: {
      joindre: "Nous joindre",
      mail: "Nous contacter par mail",
      sabonner: "S'abonner",
      cookies: "Politique de cookies",
      mentions: "Mentions légales",
      confidentialite: "Politique de confidentialité",
      copyright: "©2026 Evara Monaco ©BVergely",
    },
    offresCategories: {
      "reseaux-sociaux": {
        tagline: "Une présence pensée pour marquer les esprits.",
        badge: "Le plus choisi",
        signatures: [
          { desc: "Idéal pour les entreprises souhaitant démarrer ou tester leur présence sur un seul réseau social." },
          { desc: "Idéal pour les micro-entreprises et PME souhaitant développer leur présence sur les réseaux sociaux." },
          { desc: "Idéal pour les PME et ETI souhaitant accélérer leur visibilité et attirer davantage de clientèle." },
          { desc: "Idéal pour les GE et marques établies souhaitant déléguer entièrement leur présence digitale et créer de l'impact." },
        ],
      },
      branding: {
        tagline: "Une identité qui vous ressemble.",
        badge: "Le plus choisi",
        signatures: [
          { subtitle: "Identité de base", items: ["3 propositions", "Logo principal", "Versions noir et blanc", "2 retouches", "Fichiers PNG + PDF"], delay: "Délai 7-10 jours" },
          { subtitle: "Le cœur de votre marque", items: ["Logo principal + secondaire + monogramme", "Déclinaisons du logo (versions noir et blanc)", "Palette de couleurs", "Typographies", "Mini-guide d'utilisation (logo, couleurs, typo)", "3 retouches", "Fichiers PNG, SVG, PDF"], delay: "Délai 2-3 semaines" },
          { subtitle: "Marque prête à déployer", items: ["Tout Branding Essentiel", "Direction artistique étendue", "Templates 5 posts + 3 stories", "Couvertures réseaux sociaux", "4 retouches", "Fichiers PNG, SVG, PDF"], delay: "Délai 3-4 semaines" },
        ],
      },
      print: {
        tagline: "Des supports qui mettent votre marque en lumière.",
        badge: "Le plus choisi",
        signatures: [
          { subtitle: "1 support au choix", items: ["Au choix : flyer, carte de visite, carte d'invitation, affiche ou menu", "Design cohérent avec votre identité", "Fichiers HD prêts à imprimer (PDF + PNG)", "2 allers-retours"], delay: "Délai 5-7 jours" },
          { subtitle: "Jusqu'à 3 supports", items: ["Au choix : flyer, carte, carte d'invitation, affiche, menu, dépliant", "Mise en page professionnelle", "Fichiers HD prêts à imprimer (PDF + PNG)", "3 allers-retours"], delay: "Délai 8-10 jours" },
          { subtitle: "Jusqu'à 5 supports", items: ["Au choix : flyer, carte, carte d'invitation, affiche, menu, dépliant, brochure, roll-up", "Direction artistique complète", "Conseil papier et finitions", "4 allers-retours", "Fichiers HD prêts à imprimer (PDF + PNG)"], delay: "Délai 10-15 jours" },
        ],
      },
      documents: {
        tagline: "Des documents à la hauteur de vos ambitions.",
        badge: "Le plus choisi",
        signatures: [
          { subtitle: "Document soigné", items: ["Jusqu'à 8 pages (ex. mini-dossier, one-pager)", "Mise en page professionnelle", "Cohérence avec votre identité", "2 allers-retours", "Fichier PDF HD"] },
          { subtitle: "Document premium", items: ["Jusqu'à 16 pages (ex. plaquette, dossier investisseurs)", "Direction artistique", "Mise en page avancée", "3 allers-retours", "Fichier PDF HD prêt à partager"] },
          { subtitle: "Grands formats", items: ["Brochures et catalogues", "Dossiers investisseurs", "Livrets événementiels", "Présentations haut de gamme"], price: "Sur demande" },
        ],
      },
    },
  },

  en: {
    nav: { accueil: "Home", apropos: "About", vision: "Vision", offres: "Services", contact: "Contact" },
    common: {
      devis: "Book a call",
      decouvrirOffres: "Discover the offers",
      retourAccueil: "Back to home",
      enSavoirPlus: "Learn more",
      envoyer: "Send",
      sending: "Sending...",
      decouvrir: "Discover our offers",
      successDevis: "Thank you! We'll get back to you within 24 hours.",
      successContact: "Request sent! We'll reach out shortly.",
      successNewsletter: "Thank you! You're now subscribed to our updates.",
      errorGeneric: "An error occurred. Please try again.",
    },
    popup: {
      title: "Welcome",
      subtitle: "I want to subscribe and receive your updates.",
      placeholder: "Your email address",
      close: "Close",
    },
    home: {
      heroTitle1: "Visual Creation",
      heroTitleItalic: "&",
      heroTitle2: "Digital Marketing Agency",
      heroTagline: "Make your visual signature stand out.",
      heroCta: "Discover our services",
      heroCta2: "Book a discovery call",
      floatingCta: "Book a call",
      floatingClose: "Close",
      heroLabel: "Monaco",
      intro1: "At EVARA, we believe a brand should be felt before it is even understood.",
      intro2: "We support entrepreneurs, retailers, restaurants and brands in their digital growth with a clear approach: **quality content**, **a coherent identity** and a message that attracts naturally.",
      intro3: "Our mission is to craft a **unique visual world** for every client by combining **creativity, strategy** and an aesthetic inspired by **Monegasque elegance**.",
      signaturePhrase: "Your image. Your signature.",
      approcheTitle: "Our approach",
      approcheSub: "How does EVARA work?",
      steps: [
        { t: "Analysis", d: "We start by analysing **your brand, your market and your audience** to understand your objectives and identify growth opportunities." },
        { t: "Discovery call", d: "We then schedule a call to discuss your project, your needs and the most relevant **strategic direction** for your brand." },
        { t: "Strategy", d: "We design a **tailor-made strategy** aligned with your goals in order to position your brand effectively." },
        { t: "Content creation", d: "We design and produce content tailored to your image to strengthen your **visibility and impact**." },
        { t: "Optimisation & follow-up", d: "We track results regularly and optimise the actions in place to guarantee **lasting performance**." },
      ],
      offresTitle: "How do you want to leave a mark on social media?",
      offresSub: "Tailor-made solutions for every need.",
      trustTitle: "They have trusted us",
      tiers: [
        { title: "Start on social media", desc: "You want to create or test your online presence and start publishing content regularly.", note: "(1 platform)" },
        { title: "Maintain a consistent presence", desc: "You want to stay active on social media with consistent content and a professional image.", note: "(2 platforms)" },
        { title: "Grow your visibility and audience", desc: "You want to attract more customers and grow your audience through an optimised strategy.", note: "(2 platforms or more)" },
        { title: "Build a true brand", desc: "You want to delegate the management of your channels and develop a true brand identity.", note: "(2 platforms or more)" },
      ],
      devisTitle: "Book a call",
      devisSub: "Let's talk about your project and digital ambitions together.",
      devisPrenom: "First name *",
      devisNom: "Last name *",
      devisEmail: "Email *",
    },
    apropos: {
      title: "About",
      s1: [
        "Founded in Monaco, EVARA is first and foremost the fruit of a passion for **visual creation** and **digital marketing**.",
        "We support brands and businesses in growing their online presence by offering a complete range of services: **digital strategy, social media management, content creation, branding** and marketing support.",
        "Our goal is to help every brand structure its image and build a **strong, coherent digital presence**.",
      ],
      s2: [
        "Every project is tailor-made to reflect the **unique identity** of our clients and capture attention on Instagram, Facebook, TikTok, LinkedIn and beyond.",
        "From strategic thinking to content production, we combine **creativity, strategy and performance** to turn your digital presence into a true **growth lever**.",
      ],
      s3: [
        "The name EVARA, inspired by \"everyone\" and \"everlasting\", symbolises the **trust** and **lasting relationships** we build with our clients.",
        "It embodies a **modern, elegant and internationally minded** vision.",
      ],
      s3Quote: "EVARA is more than an agency: it is a signature.",
      s4: [
        "At the heart of this agency lies a sensitivity for **aesthetics, detail** and the way a brand can leave a **lasting imprint**.",
        "“Through my journey, I have developed a strong conviction: today, standing out no longer rests on what you offer alone, but on **how you tell it** and how you bring it to life.”",
        "This vision guides every project. Deeply understanding the world, ambitions and identity of a brand is essential to build a presence that is **coherent, impactful and lasting**.",
        "EVARA was born from this requirement: supporting ambitious brands with **accuracy, creativity** and a deeply **human** approach.",
      ],
      founderCaption: "Founder of EVARA",
      ctaBanner: "What if we gave your brand a signature?",
    },
    vision: {
      title: "At EVARA,",
      p1: "We design strategies and content that allow brands to **stand out** in a constantly evolving digital world.",
      p2: "Our mission is to combine **creativity, identity and performance** to build strong, coherent and memorable online presences.",
      block1: "Our expertise is built around **four essential pillars**: **content creation, social media management, branding and visual support design**. These services were developed to support brands at every stage of their evolution, from building their identity to growing their visibility.",
      block2: "Every collaboration is **fully tailor-made**. As a brand's needs are unique, our offers are modular and adapted to your goals, providing **flexible, strategic and lasting** support.",
      piliersTitle: "Our pillars",
      services: {
        "creation-de-contenu": "Content creation",
        "social-media-management": "Social Media Management",
        "branding-identite-visuelle": "Branding & visual identity",
        "creations-print": "Print & physical creations",
      },
    },
    offres: {
      title: "Choose your signature",
      subtitle: "Four services, each available in several levels of support, to meet your brand’s needs and support its growth at every stage.",
      moreInfo: "More info",
      offers: {
        FOCUS: "Ideal for businesses wishing to launch or test their presence on a single social network.",
        START: "Ideal for micro-businesses and SMBs looking to grow their presence on social media.",
        ESSENTIAL: "Ideal for SMBs and mid-caps wanting to accelerate visibility and attract more customers.",
        PREMIUM: "Ideal for large groups and established brands wishing to fully delegate their digital presence and create impact.",
      },
      modulableIntro: "Still in doubt? We've thought of you.",
      modulableTitle: "Modular offer",
      modulableDesc: "Ideal for businesses wishing to fully personalise their digital growth.",
    },
    contact: {
      title: "Contact us",
      adresseLabel: "Address",
      adresseValue: "Monaco, 98 000",
      contactLabel: "Contact",
      horairesLabel: "Opening hours",
      horaires: ["Mon–Fri · 10am – 2pm", "Saturday · Closed", "Sunday · Closed"],
      rdvTitle: "Let's meet",
      rdvDesc: "Share a few details about your company and your needs. This will help us understand your project and prepare our first discussion.",
      formNom: "Name *",
      formEmail: "Email *",
      formTel: "Phone number",
      formType: "Are you a professional or a private individual?",
      typePro: "Professional",
      typePart: "Private individual",
      formSecteur: "What sector are you in?",
      formSecteurPlaceholder: "Choose a sector…",
      formBudget: "Monthly budget",
      formBudgetPlaceholder: "Choose a budget…",
      formServices: "Which service(s) interest you?",
      formSource: "How did you hear about EVARA?",
      formSourcePlaceholder: "Select…",
      formMessage: "Any questions or details to share?",
      formSubmit: "Send request",
      formIntro: "Tell us a little more about yourself…",
      secteurs: ["Restaurants", "Hospitality", "Real estate", "Luxury", "Fashion & Beauty", "Health & Wellness", "Consulting & B2B services", "Retail", "Sport & Fitness", "Events", "Other"],
      budgets: ["< €500", "€500 – €1,500", "€1,500 – €3,000", "€3,000 – €5,000", "€5,000 +", "To be defined"],
      sources: ["Instagram", "LinkedIn", "TikTok", "Referral", "Google", "Other"],
      services: ["Content creation", "Social media management", "Branding & visual identity", "Logo design", "Print & physical creations"],
    },
    serviceDetail: {
      back: "Back",
      prestationsHidden: "Services",
      otherServicesHidden: "Our other pillars",
      data: {
        "creation-de-contenu": {
          label: "Content creation",
          title: "High-value content production",
          description: "We design and produce visual content designed to **capture attention and enhance your brand** across all your channels. Each project is part of a strategic vision to ensure **coherence, quality execution and impact**.",
          prestations: ["Photo & video production", "Short-form formats (Reels, TikTok)", "Art direction", "Post-production & editing"],
        },
        "social-media-management": {
          label: "Social Media Management",
          title: "Strategic management of your social channels",
          description: "We take charge of the **full management** of your social media presence, building tailor-made strategies to **grow your audience, engage your community** and reinforce your brand identity.",
          prestations: ["Editorial strategy & calendar", "Community management", "Publishing & engagement", "Performance analysis & reporting"],
        },
        "branding-identite-visuelle": {
          label: "Branding & visual identity",
          title: "Building a strong visual identity",
          description: "We create **unique, coherent visual worlds** that allow your brand to stand out durably. From logo design to a complete identity definition, we build a **visual signature in your image**.",
          prestations: ["Logo design", "Graphic charter", "Art direction", "Visual world & moodboard"],
        },
        "creations-print": {
          label: "Print & physical creations",
          title: "Physical supports at the service of your brand",
          description: "We design **premium printed supports** to extend your identity into the physical world. Business cards, brochures, flyers, packaging: each creation is designed to reflect **the elegance and quality of your brand**.",
          prestations: ["Business cards & stationery", "Brochures & catalogues", "Flyers & posters", "Packaging & event supports"],
        },
      },
    },
    footer: {
      joindre: "Call us",
      mail: "Email us",
      sabonner: "Follow us",
      cookies: "Cookie policy",
      mentions: "Legal notice",
      confidentialite: "Privacy policy",
      copyright: "©2026 Evara Monaco ©BVergely",
    },
    offresCategories: {
      "reseaux-sociaux": {
        tagline: "A presence designed to leave a mark.",
        badge: "Most chosen",
        signatures: [
          { desc: "Ideal for businesses wishing to launch or test their presence on a single social network." },
          { desc: "Ideal for micro-businesses and SMBs looking to grow their presence on social media." },
          { desc: "Ideal for SMBs and mid-caps wanting to accelerate visibility and attract more customers." },
          { desc: "Ideal for large groups and established brands wishing to fully delegate their digital presence and create impact." },
        ],
      },
      branding: {
        tagline: "An identity that reflects who you are.",
        badge: "Most chosen",
        signatures: [
          { subtitle: "Core identity", items: ["3 proposals", "Main logo", "Black and white versions", "2 revisions", "PNG + PDF files"], delay: "Delivery 7-10 days" },
          { subtitle: "The heart of your brand", items: ["Main logo + secondary + monogram", "Logo variations (black and white versions)", "Colour palette", "Typography", "Mini usage guide (logo, colours, type)", "3 revisions", "PNG, SVG, PDF files"], delay: "Delivery 2-3 weeks" },
          { subtitle: "Brand ready to deploy", items: ["Everything in Branding Essential", "Extended art direction", "5 post + 3 story templates", "Social media covers", "4 revisions", "PNG, SVG, PDF files"], delay: "Delivery 3-4 weeks" },
        ],
      },
      print: {
        tagline: "Print supports that put your brand in the spotlight.",
        badge: "Most chosen",
        signatures: [
          { subtitle: "1 support of your choice", items: ["Your choice: flyer, business card, invitation card, poster or menu", "Design aligned with your identity", "HD print-ready files (PDF + PNG)", "2 rounds of revisions"], delay: "Delivery 5-7 days" },
          { subtitle: "Up to 3 supports", items: ["Your choice: flyer, card, invitation card, poster, menu, leaflet", "Professional layout", "HD print-ready files (PDF + PNG)", "3 rounds of revisions"], delay: "Delivery 8-10 days" },
          { subtitle: "Up to 5 supports", items: ["Your choice: flyer, card, invitation card, poster, menu, leaflet, brochure, roll-up", "Full art direction", "Paper and finishing advice", "4 rounds of revisions", "HD print-ready files (PDF + PNG)"], delay: "Delivery 10-15 days" },
        ],
      },
      documents: {
        tagline: "Documents that match your ambitions.",
        badge: "Most chosen",
        signatures: [
          { subtitle: "Polished document", items: ["Up to 8 pages (e.g. mini-report, one-pager)", "Professional layout", "Aligned with your identity", "2 rounds of revisions", "HD PDF file"] },
          { subtitle: "Premium document", items: ["Up to 16 pages (e.g. brochure, investor deck)", "Art direction", "Advanced layout", "3 rounds of revisions", "HD PDF ready to share"] },
          { subtitle: "Large formats", items: ["Brochures and catalogues", "Investor decks", "Event booklets", "High-end presentations"], price: "On request" },
        ],
      },
    },
  },

  es: {
    nav: { accueil: "Inicio", apropos: "Quiénes somos", vision: "Visión", offres: "Servicios", contact: "Contacto" },
    common: {
      devis: "Reservar una cita",
      decouvrirOffres: "Descubrir las ofertas",
      retourAccueil: "Volver al inicio",
      enSavoirPlus: "Saber más",
      envoyer: "Enviar",
      sending: "Enviando...",
      decouvrir: "Descubrir nuestras ofertas",
      successDevis: "¡Gracias! Le responderemos en 24 horas.",
      successContact: "¡Solicitud enviada! Le contactaremos pronto.",
      successNewsletter: "¡Gracias! Está suscrito a nuestras novedades.",
      errorGeneric: "Se ha producido un error. Inténtelo de nuevo.",
    },
    popup: {
      title: "Bienvenido",
      subtitle: "Quiero suscribirme y recibir vuestras novedades.",
      placeholder: "Su dirección de correo",
      close: "Cerrar",
    },
    home: {
      heroTitle1: "Agencia de Creación",
      heroTitleItalic: "Visual y",
      heroTitle2: "Marketing Digital",
      heroTagline: "Imponga su firma visual.",
      heroCta: "Descubrir nuestros servicios",
      heroCta2: "Reservar una llamada de descubrimiento",
      floatingCta: "Reservar una llamada",
      floatingClose: "Cerrar",
      heroLabel: "Mónaco",
      intro1: "En EVARA, creemos que una marca debe sentirse antes incluso de comprenderse.",
      intro2: "Acompañamos a emprendedores, comercios, restaurantes y marcas en su desarrollo digital con un enfoque claro: **contenido de calidad**, **una identidad coherente** y un mensaje capaz de atraer de forma natural.",
      intro3: "Nuestra misión es crear un **universo visual único** para cada cliente, combinando **creatividad, estrategia** y una estética inspirada en la **elegancia monegasca**.",
      signaturePhrase: "Su imagen. Su firma.",
      approcheTitle: "Nuestro enfoque",
      approcheSub: "¿Cómo funciona EVARA?",
      steps: [
        { t: "Análisis", d: "Comenzamos analizando **su marca, su mercado y su audiencia** para comprender sus objetivos e identificar oportunidades de desarrollo." },
        { t: "Cita inicial", d: "Organizamos una reunión para hablar de su proyecto, sus necesidades y la **dirección estratégica** más adecuada a su marca." },
        { t: "Estrategia", d: "Elaboramos una **estrategia a medida** alineada con sus objetivos para posicionar eficazmente su marca." },
        { t: "Creación de contenido", d: "Diseñamos y producimos contenido adaptado a su imagen para reforzar su **visibilidad** y su **impacto**." },
        { t: "Optimización y seguimiento", d: "Realizamos un seguimiento regular y optimizamos las acciones para garantizar **resultados duraderos**." },
      ],
      offresTitle: "¿Cómo desea marcar la diferencia en redes sociales?",
      offresSub: "Soluciones a medida para cada necesidad.",
      trustTitle: "Han confiado en nosotros",
      tiers: [
        { title: "Empezar en redes sociales", desc: "Quiere crear o probar su presencia en línea y empezar a publicar contenido con regularidad.", note: "(1 plataforma)" },
        { title: "Mantener una presencia regular", desc: "Quiere mantenerse activo con contenido coherente y una imagen profesional.", note: "(2 plataformas)" },
        { title: "Desarrollar visibilidad y audiencia", desc: "Quiere atraer más clientes y hacer crecer su audiencia con una estrategia optimizada.", note: "(2 plataformas o más)" },
        { title: "Construir una verdadera marca", desc: "Quiere delegar la gestión de sus redes y desarrollar una verdadera identidad de marca.", note: "(2 plataformas o más)" },
      ],
      devisTitle: "Reservar un intercambio",
      devisSub: "Conversemos sobre su proyecto y sus ambiciones digitales.",
      devisPrenom: "Nombre *",
      devisNom: "Apellidos *",
      devisEmail: "Correo *",
    },
    apropos: {
      title: "Quiénes somos",
      s1: [
        "Fundada en Mónaco, EVARA es ante todo el fruto de una pasión por la **creación visual** y el **marketing digital**.",
        "Acompañamos a marcas y empresas en el desarrollo de su presencia en línea ofreciendo una gama completa de servicios: **estrategia digital, gestión de redes sociales, creación de contenido, branding** y acompañamiento de marketing.",
        "Nuestro objetivo es ayudar a cada marca a estructurar su imagen y construir una **presencia digital fuerte y coherente**.",
      ],
      s2: [
        "Cada proyecto se concibe a medida para reflejar la **identidad única** de nuestros clientes y captar la atención en Instagram, Facebook, TikTok, LinkedIn y mucho más allá.",
        "De la reflexión estratégica a la producción de contenido, combinamos **creatividad, estrategia y rendimiento** para transformar su presencia digital en una verdadera **palanca de crecimiento**.",
      ],
      s3: [
        "El nombre EVARA, inspirado en «everyone» y «everlasting», simboliza la **confianza** y las **relaciones duraderas** que construimos con nuestros clientes.",
        "Encarna una visión **moderna, elegante y orientada a lo internacional**.",
      ],
      s3Quote: "EVARA es más que una agencia: es una firma.",
      s4: [
        "En el origen de esta agencia hay una sensibilidad por **la estética, el detalle** y la forma en que una marca puede dejar una **huella duradera**.",
        "«A lo largo de mi trayectoria he desarrollado una convicción firme: hoy, destacarse no depende solo de lo que se ofrece, sino de **cómo se cuenta** y se hace vivir.»",
        "Esta visión guía cada proyecto. Comprender en profundidad el universo, las ambiciones y la identidad de una marca es esencial para construir una presencia **coherente, impactante y duradera**.",
        "EVARA nació de esta exigencia: acompañar a marcas ambiciosas con **precisión, creatividad** y un enfoque profundamente **humano**.",
      ],
      founderCaption: "Fundadora de EVARA",
      ctaBanner: "¿Y si le diéramos una firma a su marca?",
    },
    vision: {
      title: "En EVARA,",
      p1: "Diseñamos estrategias y contenidos que permiten a las marcas **destacarse** en un universo digital en constante evolución.",
      p2: "Nuestra misión es combinar **creatividad, identidad y rendimiento** para construir presencias en línea fuertes, coherentes y memorables.",
      block1: "Nuestra experiencia se articula en torno a **cuatro pilares esenciales**: **la creación de contenido, la gestión de redes sociales, el branding y el diseño de soportes visuales**. Estos servicios se han desarrollado para acompañar a las marcas en cada etapa de su evolución.",
      block2: "Cada colaboración es **totalmente a medida**. Como las necesidades de cada marca son únicas, nuestras ofertas son modulables y adaptadas a sus objetivos, para un acompañamiento **flexible, estratégico y duradero**.",
      piliersTitle: "Nuestros pilares",
      services: {
        "creation-de-contenu": "Creación de contenido",
        "social-media-management": "Gestión de Redes Sociales",
        "branding-identite-visuelle": "Branding e identidad visual",
        "creations-print": "Creaciones impresas y soportes físicos",
      },
    },
    offres: {
      title: "Elija su firma",
      subtitle: "Cuatro servicios, cada uno declinado en varios niveles de acompañamiento, para responder a las necesidades de su marca y apoyar su desarrollo en cada etapa.",
      moreInfo: "Más información",
      offers: {
        FOCUS: "Ideal para empresas que quieran iniciar o probar su presencia en una sola red social.",
        START: "Ideal para microempresas y pymes que quieran desarrollar su presencia en redes sociales.",
        ESSENTIAL: "Ideal para pymes y empresas medianas que deseen acelerar su visibilidad y atraer más clientes.",
        PREMIUM: "Ideal para grandes empresas y marcas establecidas que deseen delegar por completo su presencia digital.",
      },
      modulableIntro: "¿Aún tiene dudas? Hemos pensado en usted.",
      modulableTitle: "Oferta modulable",
      modulableDesc: "Ideal para empresas que deseen personalizar su desarrollo digital.",
    },
    contact: {
      title: "Contáctenos",
      adresseLabel: "Dirección",
      adresseValue: "Mónaco, 98 000",
      contactLabel: "Contacto",
      horairesLabel: "Horario de apertura",
      horaires: ["Lun–Vie · 10h – 14h", "Sábado · Cerrado", "Domingo · Cerrado"],
      rdvTitle: "Concertemos una cita",
      rdvDesc: "Comparta algunos datos sobre su empresa y sus necesidades. Esto nos permitirá comprender mejor su proyecto y preparar nuestra primera mera conversación.",
      formNom: "Nombre *",
      formEmail: "Correo *",
      formTel: "Número de teléfono",
      formType: "¿Es usted un profesional o un particular?",
      typePro: "Profesional",
      typePart: "Particular",
      formSecteur: "¿En qué sector se encuentra?",
      formSecteurPlaceholder: "Elija un sector…",
      formBudget: "Presupuesto mensual",
      formBudgetPlaceholder: "Elija un presupuesto…",
      formServices: "¿Qué servicio(s) le interesa(n)?",
      formSource: "¿Cómo nos ha conocido?",
      formSourcePlaceholder: "Seleccione…",
      formMessage: "¿Preguntas o detalles que compartir?",
      formSubmit: "Finalizar mi solicitud",
      formIntro: "Cuéntenos un poco más sobre usted…",
      secteurs: ["Restauración", "Hostelería", "Inmobiliario", "Lujo", "Moda y Belleza", "Salud y Bienestar", "Consultoría y servicios B2B", "Comercio minorista", "Deporte y Fitness", "Eventos", "Otro"],
      budgets: ["< 500 €", "500 € – 1 500 €", "1 500 € – 3 000 €", "3 000 € – 5 000 €", "5 000 € +", "Por definir"],
      sources: ["Instagram", "LinkedIn", "TikTok", "Recomendación", "Google", "Otro"],
      services: ["Creación de contenido", "Gestión de redes sociales", "Branding e identidad visual", "Diseño de logotipo", "Creaciones impresas y soportes físicos"],
    },
    serviceDetail: {
      back: "Volver",
      data: {
        "creation-de-contenu": {
          label: "Creación de contenido",
          title: "Producción de contenido de alto valor",
          description: "Diseñamos y producimos contenido visual pensado para **captar la atención y valorizar su marca** en todos sus canales. Cada proyecto se inscribe en una reflexión estratégica para asegurar **coherencia, calidad e impacto**.",
          prestations: ["Producción foto y vídeo", "Formatos cortos (Reels, TikTok)", "Dirección artística", "Postproducción y montaje"],
        },
        "social-media-management": {
          label: "Gestión de Redes Sociales",
          title: "Gestión estratégica de sus redes sociales",
          description: "Nos hacemos cargo de la **gestión completa** de su presencia en redes sociales, elaborando estrategias a medida para **desarrollar su audiencia, comprometer a su comunidad** y reforzar la identidad de su marca.",
          prestations: ["Estrategia editorial y calendario", "Community management", "Publicación e interacción", "Análisis y reporting"],
        },
        "branding-identite-visuelle": {
          label: "Branding e identidad visual",
          title: "Construcción de una identidad visual fuerte",
          description: "Creamos **universos visuales únicos y coherentes** que permiten a su marca destacarse de forma duradera. Desde el diseño del logotipo hasta la definición completa de su identidad, construimos una **firma visual a su imagen**.",
          prestations: ["Diseño de logotipo", "Manual de marca", "Dirección artística", "Universo visual y moodboard"],
        },
        "creations-print": {
          label: "Creaciones impresas y soportes físicos",
          title: "Soportes físicos al servicio de su marca",
          description: "Diseñamos **soportes impresos de alta calidad** para prolongar su identidad en el mundo físico. Tarjetas de visita, folletos, flyers, packaging: cada creación está pensada para reflejar **la elegancia y la calidad de su marca**.",
          prestations: ["Tarjetas de visita y papelería", "Folletos y catálogos", "Flyers y carteles", "Packaging y soportes de evento"],
        },
      },
    },
    footer: {
      joindre: "Llámenos",
      mail: "Escríbanos",
      sabonner: "Síganos",
      cookies: "Política de cookies",
      mentions: "Aviso legal",
      confidentialite: "Política de privacidad",
      copyright: "©2026 Evara Monaco ©BVergely",
    },
    offresCategories: {
      "reseaux-sociaux": {
        tagline: "Una presencia pensada para marcar la diferencia.",
        badge: "El más elegido",
        signatures: [
          { desc: "Ideal para empresas que desean iniciar o probar su presencia en una sola red social." },
          { desc: "Ideal para microempresas y pymes que desean desarrollar su presencia en redes sociales." },
          { desc: "Ideal para pymes y empresas medianas que buscan acelerar su visibilidad y atraer más clientes." },
          { desc: "Ideal para grandes empresas y marcas establecidas que desean delegar por completo su presencia digital." },
        ],
      },
      branding: {
        tagline: "Una identidad que le represente.",
        badge: "El más elegido",
        signatures: [
          { subtitle: "Identidad de base", items: ["3 propuestas", "Logotipo principal", "Versiones en blanco y negro", "2 retoques", "Archivos PNG + PDF"], delay: "Plazo 7-10 días" },
          { subtitle: "El corazón de su marca", items: ["Logotipo principal + secundario + monograma", "Variaciones del logotipo (versiones en blanco y negro)", "Paleta de colores", "Tipografías", "Mini-guía de uso (logo, colores, tipografía)", "3 retoques", "Archivos PNG, SVG, PDF"], delay: "Plazo 2-3 semanas" },
          { subtitle: "Marca lista para desplegar", items: ["Todo Branding Essentiel", "Dirección artística ampliada", "Plantillas 5 posts + 3 stories", "Portadas para redes sociales", "4 retoques", "Archivos PNG, SVG, PDF"], delay: "Plazo 3-4 semanas" },
        ],
      },
      print: {
        tagline: "Soportes que ponen su marca en primer plano.",
        badge: "El más elegido",
        signatures: [
          { subtitle: "1 soporte a elegir", items: ["A elegir: flyer, tarjeta de visita, tarjeta de invitación, cartel o menú", "Diseño coherente con su identidad", "Archivos HD listos para imprimir (PDF + PNG)", "2 rondas de revisiones"], delay: "Plazo 5-7 días" },
          { subtitle: "Hasta 3 soportes", items: ["A elegir: flyer, tarjeta, tarjeta de invitación, cartel, menú, folleto", "Maquetación profesional", "Archivos HD listos para imprimir (PDF + PNG)", "3 rondas de revisiones"], delay: "Plazo 8-10 días" },
          { subtitle: "Hasta 5 soportes", items: ["A elegir: flyer, tarjeta, tarjeta de invitación, cartel, menú, folleto, brochure, roll-up", "Dirección artística completa", "Asesoramiento en papel y acabados", "4 rondas de revisiones", "Archivos HD listos para imprimir (PDF + PNG)"], delay: "Plazo 10-15 días" },
        ],
      },
      documents: {
        tagline: "Documentos a la altura de sus ambiciones.",
        badge: "El más elegido",
        signatures: [
          { subtitle: "Documento cuidado", items: ["Hasta 8 páginas (ej. mini-dosier, one-pager)", "Maquetación profesional", "Coherencia con su identidad", "2 rondas de revisiones", "Archivo PDF HD"] },
          { subtitle: "Documento premium", items: ["Hasta 16 páginas (ej. folleto, dosier de inversores)", "Dirección artística", "Maquetación avanzada", "3 rondas de revisiones", "PDF HD listo para compartir"] },
          { subtitle: "Grandes formatos", items: ["Folletos y catálogos", "Dosieres de inversores", "Libros de eventos", "Presentaciones de alta gama"], price: "Bajo consulta" },
        ],
      },
    },
  },

  it: {
    nav: { accueil: "Home", apropos: "Chi siamo", vision: "Visione", offres: "Servizi", contact: "Contatti" },
    common: {
      devis: "Prenota un appuntamento",
      decouvrirOffres: "Scopri le offerte",
      retourAccueil: "Torna alla home",
      enSavoirPlus: "Scopri di più",
      envoyer: "Invia",
      sending: "Invio in corso...",
      decouvrir: "Scopri le nostre offerte",
      successDevis: "Grazie! Le risponderemo entro 24 ore.",
      successContact: "Richiesta inviata! La ricontatteremo a breve.",
      successNewsletter: "Grazie! Si è iscritta alle nostre novità.",
      errorGeneric: "Si è verificato un errore. Riprovi.",
    },
    popup: {
      title: "Benvenuta",
      subtitle: "Voglio iscrivermi e ricevere le vostre novità.",
      placeholder: "Il suo indirizzo email",
      close: "Chiudi",
    },
    home: {
      heroTitle1: "Agenzia di Creazione",
      heroTitleItalic: "Visiva e",
      heroTitle2: "Marketing Digitale",
      heroTagline: "Imponga la sua firma visiva.",
      heroCta: "Scopri i nostri servizi",
      heroCta2: "Prenota una call conoscitiva",
      floatingCta: "Prenota una call",
      floatingClose: "Chiudi",
      heroLabel: "Monaco",
      intro1: "Da EVARA, crediamo che un marchio debba farsi sentire prima ancora di essere compreso.",
      intro2: "Accompagniamo imprenditori, attività commerciali, ristoranti e marchi nel loro sviluppo digitale con un approccio chiaro: **contenuti di qualità**, **un'identità coerente** e un messaggio capace di attrarre in modo naturale.",
      intro3: "La nostra missione è creare un **universo visivo unico** per ogni cliente, unendo **creatività, strategia** ed un'estetica ispirata all'**eleganza monegasca**.",
      signaturePhrase: "La sua immagine. La sua firma.",
      approcheTitle: "Il nostro approccio",
      approcheSub: "Come funziona EVARA?",
      steps: [
        { t: "Analisi", d: "Iniziamo analizzando **il suo marchio, il suo mercato e il suo pubblico** per comprendere i suoi obiettivi e individuare le opportunità di sviluppo." },
        { t: "Appuntamento", d: "Organizziamo un incontro per discutere del suo progetto, delle sue esigenze e della **direzione strategica** più adatta al suo marchio." },
        { t: "Strategia", d: "Elaboriamo una **strategia su misura** allineata ai suoi obiettivi per posizionare efficacemente il suo marchio." },
        { t: "Creazione di contenuti", d: "Progettiamo e produciamo contenuti adattati alla sua immagine per rafforzare la sua **visibilità** e il suo **impatto**." },
        { t: "Ottimizzazione e monitoraggio", d: "Garantiamo un monitoraggio regolare e ottimizziamo le azioni intraprese per assicurare **risultati duraturi**." },
      ],
      offresTitle: "Come desidera lasciare il segno sui social?",
      offresSub: "Soluzioni su misura per ogni sua esigenza.",
      trustTitle: "Ci hanno dato fiducia",
      tiers: [
        { title: "Iniziare sui social", desc: "Vuole creare o testare la sua presenza online e iniziare a pubblicare contenuti regolarmente.", note: "(1 piattaforma)" },
        { title: "Mantenere una presenza regolare", desc: "Vuole rimanere attivo sui social con contenuti coerenti e un'immagine professionale.", note: "(2 piattaforme)" },
        { title: "Sviluppare visibilità e pubblico", desc: "Vuole attirare più clienti e far crescere il suo pubblico con una strategia ottimizzata.", note: "(2 piattaforme o più)" },
        { title: "Costruire un vero marchio", desc: "Vuole delegare la gestione dei suoi social e sviluppare una vera identità.", note: "(2 piattaforme o più)" },
      ],
      devisTitle: "Prenota un incontro",
      devisSub: "Parliamo insieme del suo progetto e delle sue ambizioni digitali.",
      devisPrenom: "Nome *",
      devisNom: "Cognome *",
      devisEmail: "Email *",
    },
    apropos: {
      title: "Chi siamo",
      s1: [
        "Fondata a Monaco, EVARA è prima di tutto il frutto di una passione per la **creazione visiva** e il **marketing digitale**.",
        "Accompagniamo marchi e aziende nello sviluppo della loro presenza online offrendo una gamma completa di servizi: **strategia digitale, gestione dei social, creazione di contenuti, branding** e supporto marketing.",
        "Il nostro obiettivo è aiutare ogni marchio a strutturare la propria immagine e costruire una **presenza digitale forte e coerente**.",
      ],
      s2: [
        "Ogni progetto è pensato su misura per riflettere l'**identità unica** dei nostri clienti e catturare l'attenzione su Instagram, Facebook, TikTok, LinkedIn e oltre.",
        "Dalla riflessione strategica alla produzione di contenuti, uniamo **creatività, strategia e performance** per trasformare la sua presenza digitale in una vera **leva di crescita**.",
      ],
      s3: [
        "Il nome EVARA, ispirato a «everyone» e «everlasting», simboleggia la **fiducia** e le **relazioni durature** che costruiamo con i nostri clienti.",
        "Incarna una visione **moderna, elegante e orientata all'internazionale**.",
      ],
      s3Quote: "EVARA è più di un'agenzia: è una firma.",
      s4: [
        "All'origine di questa agenzia vi è una sensibilità per **l'estetica, il dettaglio** e il modo in cui un marchio può lasciare un'**impronta duratura**.",
        "«Nel mio percorso ho maturato una convinzione forte: oggi, distinguersi non dipende più solo da ciò che si propone, ma da **come lo si racconta** e lo si fa vivere.»",
        "È questa visione che guida ogni progetto. Comprendere in profondità l'universo, le ambizioni e l'identità di un marchio è essenziale per costruire una presenza **coerente, d'impatto e duratura**.",
        "EVARA nasce da questa esigenza: accompagnare marchi ambiziosi con **precisione, creatività** e un approccio profondamente **umano**.",
      ],
      founderCaption: "Fondatrice di EVARA",
      ctaBanner: "E se dessimo una firma al suo marchio?",
    },
    vision: {
      title: "Da EVARA,",
      p1: "Progettiamo strategie e contenuti che permettono ai marchi di **distinguersi** in un universo digitale in continua evoluzione.",
      p2: "La nostra missione è unire **creatività, identità e performance** per costruire presenze online forti, coerenti e memorabili.",
      block1: "La nostra expertise si articola attorno a **quattro pilastri essenziali**: **la creazione di contenuti, la gestione dei social, il branding e la progettazione di supporti visivi**. Questi servizi sono stati sviluppati per accompagnare i marchi in ogni fase della loro evoluzione.",
      block2: "Ogni collaborazione è **completamente su misura**. Poiché le esigenze di ogni marchio sono uniche, le nostre offerte sono modulabili e adatte ai suoi obiettivi, per un accompagnamento **flessibile, strategico e duraturo**.",
      piliersTitle: "I nostri pilastri",
      services: {
        "creation-de-contenu": "Creazione di contenuti",
        "social-media-management": "Gestione Social Media",
        "branding-identite-visuelle": "Branding e identità visiva",
        "creations-print": "Creazioni stampa e supporti fisici",
      },
    },
    offres: {
      title: "Scelga la sua firma",
      subtitle: "Quattro servizi, ciascuno declinato in più livelli di accompagnamento, per rispondere alle esigenze del suo marchio e sostenerne lo sviluppo in ogni fase.",
      moreInfo: "Maggiori info",
      offers: {
        FOCUS: "Ideale per aziende che desiderano iniziare o testare la propria presenza su un singolo social.",
        START: "Ideale per micro-imprese e PMI che desiderano sviluppare la propria presenza sui social.",
        ESSENTIAL: "Ideale per PMI e medie aziende che vogliono accelerare la propria visibilità e attrarre più clienti.",
        PREMIUM: "Ideale per grandi gruppi e marchi affermati che desiderano delegare interamente la propria presenza digitale.",
      },
      modulableIntro: "Ancora dubbi? Abbiamo pensato a lei.",
      modulableTitle: "Offerta modulabile",
      modulableDesc: "Ideale per aziende che desiderano personalizzare il proprio sviluppo digitale.",
    },
    contact: {
      title: "Contattaci",
      adresseLabel: "Indirizzo",
      adresseValue: "Monaco, 98 000",
      contactLabel: "Contatto",
      horairesLabel: "Orari di apertura",
      horaires: ["Lun–Ven · 10h – 14h", "Sabato · Chiuso", "Domenica · Chiuso"],
      rdvTitle: "Fissiamo un appuntamento",
      rdvDesc: "Ci condivida alcune informazioni sulla sua azienda e sulle sue esigenze. Ci permetterà di comprendere meglio il progetto e preparare il primo confronto.",
      formNom: "Nome *",
      formEmail: "Email *",
      formTel: "Numero di telefono",
      formType: "È un professionista o un privato?",
      typePro: "Professionista",
      typePart: "Privato",
      formSecteur: "In quale settore opera?",
      formSecteurPlaceholder: "Scelga un settore…",
      formBudget: "Budget mensile",
      formBudgetPlaceholder: "Scelga un budget…",
      formServices: "Quale/i servizio/i la interessa?",
      formSource: "Come ha conosciuto EVARA?",
      formSourcePlaceholder: "Selezioni…",
      formMessage: "Domande o dettagli da condividere?",
      formSubmit: "Finalizza la mia richiesta",
      formIntro: "Ci racconti qualcosa in più su di lei…",
      secteurs: ["Ristorazione", "Ospitalità", "Immobiliare", "Lusso", "Moda e Bellezza", "Salute e Benessere", "Consulenza e servizi B2B", "Vendita al dettaglio", "Sport e Fitness", "Eventi", "Altro"],
      budgets: ["< 500 €", "500 € – 1 500 €", "1 500 € – 3 000 €", "3 000 € – 5 000 €", "5 000 € +", "Da definire"],
      sources: ["Instagram", "LinkedIn", "TikTok", "Passaparola", "Google", "Altro"],
      services: ["Creazione di contenuti", "Gestione social media", "Branding e identità visiva", "Creazione logo", "Stampati e supporti fisici"],
    },
    serviceDetail: {
      back: "Indietro",
      data: {
        "creation-de-contenu": {
          label: "Creazione di contenuti",
          title: "Produzione di contenuti ad alto valore",
          description: "Progettiamo e produciamo contenuti visivi pensati per **catturare l'attenzione e valorizzare il suo marchio** su tutti i canali. Ogni progetto si inscrive in una riflessione strategica per assicurare **coerenza, qualità e impatto**.",
          prestations: ["Produzione foto e video", "Formati brevi (Reels, TikTok)", "Direzione artistica", "Post-produzione e montaggio"],
        },
        "social-media-management": {
          label: "Gestione Social Media",
          title: "Gestione strategica dei suoi canali social",
          description: "Ci occupiamo della **gestione completa** della sua presenza sui social media, elaborando strategie su misura per **sviluppare il pubblico, coinvolgere la community** e rafforzare l'identità del marchio.",
          prestations: ["Strategia editoriale e calendario", "Community management", "Pubblicazione e coinvolgimento", "Analisi delle performance e reporting"],
        },
        "branding-identite-visuelle": {
          label: "Branding e identità visiva",
          title: "Costruzione di un'identità visiva forte",
          description: "Creiamo **universi visivi unici e coerenti** che permettono al suo marchio di distinguersi in modo duraturo. Dalla creazione del logo alla definizione completa dell'identità, costruiamo una **firma visiva a sua immagine**.",
          prestations: ["Creazione logo", "Manuale di brand", "Direzione artistica", "Universo visivo e moodboard"],
        },
        "creations-print": {
          label: "Creazioni stampa e supporti fisici",
          title: "Supporti fisici al servizio del suo marchio",
          description: "Progettiamo **supporti stampati di alta gamma** per prolungare la sua identità nel mondo fisico. Biglietti da visita, brochure, flyer, packaging: ogni creazione è pensata per riflettere **l'eleganza e la qualità del suo marchio**.",
          prestations: ["Biglietti da visita e cartoleria", "Brochure e cataloghi", "Flyer e poster", "Packaging e supporti evento"],
        },
      },
    },
    footer: {
      joindre: "Chiamaci",
      mail: "Scrivici",
      sabonner: "Seguici",
      cookies: "Politica dei cookie",
      mentions: "Note legali",
      confidentialite: "Informativa sulla privacy",
      copyright: "©2026 Evara Monaco ©BVergely",
    },
    offresCategories: {
      "reseaux-sociaux": {
        tagline: "Una presenza pensata per lasciare il segno.",
        badge: "Il più scelto",
        signatures: [
          { desc: "Ideale per aziende che desiderano iniziare o testare la propria presenza su un singolo social." },
          { desc: "Ideale per micro-imprese e PMI che desiderano sviluppare la propria presenza sui social." },
          { desc: "Ideale per PMI e medie aziende che vogliono accelerare la visibilità e attrarre più clienti." },
          { desc: "Ideale per grandi gruppi e marchi affermati che desiderano delegare interamente la propria presenza digitale." },
        ],
      },
      branding: {
        tagline: "Un'identità che le somigli.",
        badge: "Il più scelto",
        signatures: [
          { subtitle: "Identità di base", items: ["3 proposte", "Logo principale", "Versioni bianco e nero", "2 revisioni", "File PNG + PDF"], delay: "Consegna 7-10 giorni" },
          { subtitle: "Il cuore del suo marchio", items: ["Logo principale + secondario + monogramma", "Declinazioni del logo (versioni bianco e nero)", "Palette colori", "Tipografia", "Mini-guida d'uso (logo, colori, tipografia)", "3 revisioni", "File PNG, SVG, PDF"], delay: "Consegna 2-3 settimane" },
          { subtitle: "Marchio pronto al lancio", items: ["Tutto Branding Essentiel", "Direzione artistica estesa", "Template 5 post + 3 stories", "Copertine social", "4 revisioni", "File PNG, SVG, PDF"], delay: "Consegna 3-4 settimane" },
        ],
      },
      print: {
        tagline: "Supporti che mettono in luce il suo marchio.",
        badge: "Il più scelto",
        signatures: [
          { subtitle: "1 supporto a scelta", items: ["A scelta: flyer, biglietto da visita, biglietto d'invito, poster o menu", "Design coerente con la sua identità", "File HD pronti per la stampa (PDF + PNG)", "2 revisioni"], delay: "Consegna 5-7 giorni" },
          { subtitle: "Fino a 3 supporti", items: ["A scelta: flyer, biglietto, biglietto d'invito, poster, menu, pieghevole", "Impaginazione professionale", "File HD pronti per la stampa (PDF + PNG)", "3 revisioni"], delay: "Consegna 8-10 giorni" },
          { subtitle: "Fino a 5 supporti", items: ["A scelta: flyer, biglietto, biglietto d'invito, poster, menu, pieghevole, brochure, roll-up", "Direzione artistica completa", "Consulenza su carta e finiture", "4 revisioni", "File HD pronti per la stampa (PDF + PNG)"], delay: "Consegna 10-15 giorni" },
        ],
      },
      documents: {
        tagline: "Documenti all'altezza delle sue ambizioni.",
        badge: "Il più scelto",
        signatures: [
          { subtitle: "Documento curato", items: ["Fino a 8 pagine (es. mini-dossier, one-pager)", "Impaginazione professionale", "Coerenza con la sua identità", "2 revisioni", "File PDF HD"] },
          { subtitle: "Documento premium", items: ["Fino a 16 pagine (es. brochure, dossier investitori)", "Direzione artistica", "Impaginazione avanzata", "3 revisioni", "PDF HD pronto da condividere"] },
          { subtitle: "Grandi formati", items: ["Brochure e cataloghi", "Dossier investitori", "Libretti eventi", "Presentazioni di alta gamma"], price: "Su richiesta" },
        ],
      },
    },
  },
};

Object.entries(servicesContent).forEach(([lang, c]) => {
  const d = dictionaries[lang];
  Object.assign(d.offres, c.offres);
  d.servicesCatalog = { categories: c.categories, documentsTitle: c.documentsTitle };
  d.offresCategories.contenu = c.contenu;
});
